import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";

export default function useMembreAuth() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const token = localStorage.getItem("membreToken");

      if (!token) {
        setLoading(false);
        return;
      }

      // Vérifier que le JWT est lisible
      try {
        jwtDecode(token);
      } catch {
        localStorage.removeItem("membreToken");
        setLoading(false);
        return;
      }

      try {
        const res = await fetch("/api/membre?action=getInfo", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();

        if (data.success) {
          setUser(data.user);
        } else {
          // Token invalide, expiré ou compte suspendu
          localStorage.removeItem("membreToken");
          localStorage.removeItem("membre");
          setUser(null);
        }
      } catch (error) {
        console.error("Erreur récupération utilisateur :", error);

        // Ne pas utiliser les données du JWT comme fallback
        setUser(null);
      }

      setLoading(false);
    }

    load();
  }, []);

  return { user, loading };
}